// @ts-strict-ignore
import {Component, Injector, OnInit} from "@angular/core";
import {BasicMaterialDialog, MatDialogDataBaseInput} from "../../basic-material-dialog/basic-material-dialog.directive";
import {CameraResolutionType, CameraViewMode, DisplayMode, LiveStreamCameraLayoutOptions, WebCameraView} from "@models";
import {SimCameraService} from "@services";
import {EventEmitterService} from "@event-emitter";

export interface DialogData_CameraPreviewDialog extends MatDialogDataBaseInput {
	camId: string;
}

@Component({
	selector: "sim-camera-station-preview-dialog",
	templateUrl: "./camera-preview-dialog.component.html",
	styleUrls: ["./camera-preview-dialog.component.scss"],
	providers: [EventEmitterService],
	standalone: false,
})
export class CameraPreviewDialogComponent
	extends BasicMaterialDialog<CameraPreviewDialogComponent, DialogData_CameraPreviewDialog>
	implements OnInit
{
	public camera: WebCameraView = null;
	public options: LiveStreamCameraLayoutOptions = <LiveStreamCameraLayoutOptions>{
		displayMode: DisplayMode.Auto,
		preferredStream: CameraResolutionType.RecordingWindow,
		preferredFullscreenStream: CameraResolutionType.RecordingWindowFull,
		cameraViewMode: CameraViewMode.AllScreens,
	};

	constructor(
		_injector: Injector,
		protected _simCameraService: SimCameraService,
		private _emitterService: EventEmitterService,
	) {
		super(_injector);
	}

	public async ngOnInit() {
		super.ngOnInit();

		this._emitterService.onCameraSettingsChanged.subscribe(async (args) => {
			if (this.data.camId === args.cameraId) {
				this.camera = await this._simCameraService.getCameraById(this.data.camId);
			}
		});

		this.camera = await this._simCameraService.getCameraById(this.data.camId);
	}
}
